import React from 'react';
interface Problem {
  icon: string;
  title: string;
  description: string;
  stat: string;
}
interface ProblemSlideProps {
  content: {
    problems: Problem[];
  };
}
export function ProblemSlide({
  content
}: ProblemSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-171">
      <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-172">
        The AI Response Challenge
      </h2>
      <p className="text-xl text-[#4D4D4D] mb-12" data-id="element-173">
        Why traditional approaches are failing businesses
      </p>

      <div className="grid grid-cols-2 gap-6" data-id="element-174">
        {content.problems.map((problem, index) => <div key={index} className="bg-white rounded-xl p-8 border border-[#4D4D4D]/10 hover:border-[#0FB07D] transition-colors" data-id="element-175">
            <div className="text-5xl mb-4" data-id="element-176">{problem.icon}</div>
            <h3 className="text-2xl font-bold text-[#1C1C1C] mb-3" data-id="element-177">
              {problem.title}
            </h3>
            <p className="text-[#4D4D4D] mb-4 leading-relaxed" data-id="element-178">
              {problem.description}
            </p>
            <div className="text-2xl font-bold text-[#0FB07D]" data-id="element-179">
              {problem.stat}
            </div>
          </div>)}
      </div>
    </div>;
}
export default ProblemSlide;